module.exports = __webpack_public_path__ + "img/spiral-details1.c05f1a80.png";